import { globalStyles } from '../design-tokens';

export const CssBaseline: React.FC = () => {
  globalStyles();
  return null;
};

CssBaseline.displayName = 'CssBaseline';
